export default "__VITE_ASSET__$pNbrOxf__"